import { posthog } from '@/lib/posthog';
import React from 'react';
import { ErrorScreen } from './ErrorScreen';

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Catches render errors that occur outside the data router (providers, the router itself).
 */
export class RootErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    posthog.captureException(error, {
      source: 'root_error_boundary',
      componentStack: info.componentStack,
    });
  }

  render() {
    const { error } = this.state;

    if (!error) return this.props.children;

    return (
      <ErrorScreen
        title="Beacon ran into a problem"
        description="Something went wrong and the page couldn't recover on its own. Reloading usually fixes it."
        onReload={() => window.location.reload()}
        onHome={() => {
          window.location.href = '/';
        }}
      />
    );
  }
}
